import React from 'react';
import { FORM_ROOT_CLASS, formRootAttributes } from '~/lib/FormCssApi';
import { FormCustomCssProvider } from '~/lib/FormCustomCssContext';

/**
 * Puts a business's custom CSS around the admin form designer.
 *
 * The designer themes each question with its own ThemedForm, so none of those
 *  wraps the preview as a whole. This owns the scope root instead, which also
 *  pulls the background and the container inside it the way they are on the
 *  live form.
 *
 * The css must be the sanitized version. The raw text a business types is
 *  unscoped, and injecting that into the admin app would let a stray
 *  `body { display: none }` take out everything around the preview.
 */
const CustomCssScope = ({ css, objectType, objectId, className, children }) => {
    return (
        <div
            className={`${FORM_ROOT_CLASS} ${className ?? ''}`}
            {...formRootAttributes({ objectType, objectId })}
        >
            {/* Custom questions render in their own document, which this
                stylesheet doesn't reach, so it is handed to them too */}
            <FormCustomCssProvider css={css}>{children}</FormCustomCssProvider>

            {/* After the children, not before: each question's ThemedForm
                writes its theme into the tree below, and on the live form the
                custom CSS comes after the theme. Emitting it first would let
                the theme win ties here but not in production, so the preview
                would disagree with the real thing. */}
            {!!css && <style type="text/css">{css}</style>}
        </div>
    );
};

export default CustomCssScope;
